module.exports = __webpack_public_path__ + "static/media/13.77f89139.jpeg";